export class EVENTS {
  public static LOCK = 'lock';
  public static UNLOCK = 'unlock';
  public static LOCK_FORWARD = 'lockForward';
  public static COMPLETED = 'completed';
  public static REFRESHED = 'refreshed';
}

export class KNOWLEDGE_CHECK_EVENTS {
  public static OPTION_MOUNTED = 'kc-option-mounted';
  public static AFTER_OPTION_MOUNTED = 'kc-after-mounted';
  public static CLEAR_OPTIONS = 'kc-clear-options';
  public static OPTION_SELECTED = 'kc-option-selected';
  public static MOUNTED = 'kc-mounted';
  public static SHOWING_FEEDBACK = 'kc-showing-feedback';
  public static TURN_INTO_FOLDER_POOL = 'kc-turn-it-into-folder-pool';
  public static NEXT = 'kc-next';
  public static SHOW_FINAL_FEEDBACK = 'kc-show-final-feedback';
  public static IS_LAST_QUESTION = 'kc-is-last-question';
}